"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APOS_UPLOAD_FROM_URL_ERROR_CODES = exports.APosUploadFromUrlResponseSchema = exports.APosUploadFromUrlRequestSchema = void 0;
const zod_1 = require("zod");
/**
 * AgenticPOS uploads-service — `POST /tenant/{tenantId}/uploads/from-url`
 *
 * Wave 1 Track C endpoint. Accepts a third-party image URL that was
 * previously returned by a product_assist operation and server-side
 * downloads + re-uploads it to the tenant's S3 bucket so the browser
 * never has to cross-origin fetch it.
 *
 * SSRF protection layers (enforced by handler, not schema):
 *   1. operationId gate — URL must be in the 10-minute operation cache
 *   2. https:// protocol only
 *   3. DNS resolution rejects RFC1918 / loopback / link-local / metadata
 *   4. Max 3 redirects, each re-validated
 *   5. Content-Type must start with `image/`
 *   6. 5MB streaming size cap
 *   7. 10 second hard timeout
 */
// ---------- POST /tenant/{tenantId}/uploads/from-url ----------
exports.APosUploadFromUrlRequestSchema = zod_1.z.object({
    /** Third-party image URL (must be https, must be in operationId cache). */
    imageUrl: zod_1.z.string().url(),
    /** Operation ID from a recent product_assist / image_search_only response. */
    operationId: zod_1.z.string().min(1),
    /** S3 folder under the tenant prefix. Defaults to `products`. */
    folder: zod_1.z.string().min(1).max(64).optional(),
});
exports.APosUploadFromUrlResponseSchema = zod_1.z.object({
    /** Public CloudFront/S3 URL to the re-uploaded image. */
    fileUrl: zod_1.z.string().url(),
    /** Raw S3 object key. */
    key: zod_1.z.string().min(1),
});
// ---------- Error codes ----------
/**
 * Stable error codes returned in `error` field of 4xx responses.
 * Keep in sync with the handler and any client that branches on them.
 */
exports.APOS_UPLOAD_FROM_URL_ERROR_CODES = {
    OPERATION_NOT_FOUND_OR_URL_NOT_ALLOWED: 'operation_not_found_or_url_not_allowed',
    INVALID_PROTOCOL: 'invalid_protocol',
    PRIVATE_IP_BLOCKED: 'private_ip_blocked',
    TOO_MANY_REDIRECTS: 'too_many_redirects',
    NOT_AN_IMAGE: 'not_an_image',
    FILE_TOO_LARGE: 'file_too_large',
    DOWNLOAD_TIMEOUT: 'download_timeout',
    DOWNLOAD_FAILED: 'download_failed',
};
//# sourceMappingURL=uploads-from-url.schema.js.map